// Textos de las páginas del cliente (2.9 a 2.11). Los T<n> son **literales** de `transicion/modulos/clientes.md` §12
// (asesoría RGPD, versión 2026-10-21, G206): cualquier cambio es una versión nueva. Los que no tienen número salen del
// dibujo (`diseno/clientes/2.9-2.11-paginas-del-cliente.html`); los marcados «TEXTO A VALIDAR» son propuestas (G242).

/** Versiones que se guardan al crear la cuenta (G190): texto informativo T10 y Condiciones de la cuenta. */
export const VERSION_AVISO = '2026-10-21';
export const VERSION_CONDICIONES = '2026-10-21';

/**
 * Direcciones de «Privacidad de Reservaria», «Condiciones de la cuenta» y el pie «Política de privacidad · Condiciones».
 * Pendientes: las páginas las publica la web pública (fase 4) y la asesoría entrega las Condiciones (G242). Mientras sean
 * `null`, se ven como texto subrayado sin enlace, igual que en la invitación (1.10).
 */
export const ENLACES_LEGALES: { privacidad: string | null; condiciones: string | null } = { privacidad: null, condiciones: null };

export const T = {
    // 12.1 Identificarse
    t1: { titulo: 'Identifícate', sub: (negocio: string) => `Para ver y gestionar lo que tienes en ${negocio}. Te mandamos un código; sin contraseñas.` },
    t2: { titulo: 'Tus datos', sub: 'Te mandamos un código para comprobar que eres tú. Sin contraseñas.' },
    t3: { titulo: 'Entra en Mis datos', sub: 'Con el teléfono o el email de tu Cuenta Reservaria. Te mandamos un código; sin contraseñas.' },
    t4b: 'Te identificas con tu Cuenta Reservaria: con el mismo teléfono entras en cualquier negocio que trabaje con Reservaria, y solo tú puedes cambiar tus datos.',
    t4: (negocio: string) =>
        `Te identificas con tu Cuenta Reservaria: con el mismo teléfono entras en cualquier negocio que trabaje con Reservaria, y solo tú puedes cambiar tus datos. Reservaria gestiona tu cuenta; ${negocio} gestiona tu reserva y lo que hagas con él.`,
    privacidadReservaria: 'Privacidad de Reservaria',
    privacidadDe: (negocio: string) => `Privacidad de ${negocio}`,
    t5: { telefono: 'Llega por WhatsApp. Otro país: +prefijo.', email: 'Solo si ya está verificado en tu cuenta.' },
    t6: { antes: 'Este sitio está protegido por reCAPTCHA y se aplican la', privacidad: 'Política de privacidad', y: 'y las', condiciones: 'Condiciones del servicio', despues: 'de Google.' },
    t7: {
        titulo: 'Escribe el código',
        whatsapp: (telefono: string) => `Te lo hemos enviado por WhatsApp al ${telefono}.`,
        // Por SMS no hay T: se sigue la forma del de WhatsApp, como el dibujo.
        sms: (telefono: string) => `Te lo hemos enviado por SMS al ${telefono}.`,
        email: (email: string) => `Te lo hemos enviado por email a ${email}. Mira también en la carpeta de correo no deseado.`,
    },
    t8: '¿No te llega? Recíbelo por SMS o email',
    t9: {
        titulo: 'Crea tu Cuenta Reservaria',
        sub: (telefono: string) => `Es la primera vez que usas el ${telefono} con Reservaria. Dinos cómo te llamas.`,
        nombre: 'Nombre y apellidos',
        email: 'Email (opcional)',
        ayudaEmail: 'Opcional. Te mandaremos también por email las confirmaciones.',
    },
    t10: 'Tu cuenta te servirá en cualquier negocio que trabaje con Reservaria. Reservaria guarda tu nombre, tu teléfono, tu email y tu idioma para identificarte. Cada negocio con el que te identifiques recibirá tu nombre, tu teléfono y tu email; lo que hagas con él (reservas, notas, lo que aceptas recibir) es solo de ese negocio, y ningún negocio sabe en qué otros estás. Solo tú puedes cambiar tus datos, desde «Mis datos». Debes tener al menos 14 años.',
    condicionesCuenta: 'Condiciones de la cuenta',
    aceptarYCrear: 'Aceptar y crear mi cuenta',
    t11: { creada: 'Hemos creado tu Cuenta Reservaria. Ya puedes seguir.', existia: 'Te hemos identificado con tu Cuenta Reservaria. Ya puedes seguir.', chip: 'Teléfono verificado', noSoyYo: 'No soy yo' },
    t12: {
        titulo: 'Este email no está en ninguna cuenta',
        sub: 'Las Cuentas Reservaria se crean con un teléfono. Identifícate con el tuyo y, si quieres, añade este email después en «Mis datos».',
    },
    t13: {
        titulo: (canal: string) => `Te mandamos la confirmación por ${canal}`,
        sub: 'Si no llega por ahí, te la mandamos por email.',
        casilla: (negocio: string, canal: string) => `Quiero recibir ofertas y novedades de ${negocio} por ${canal}`,
        ayudaAntes: 'Opcional. Puedes darte de baja en cada mensaje o en «Mis datos». Más en ',
    },
    t14: { ofrecido: 'Ofrecido por', politica: 'Política de privacidad', condiciones: 'Condiciones' },

    // 12.2 «Mis datos»
    t15: { titulo: 'Mis datos', sub: 'Tu Cuenta Reservaria y lo que compartes con cada negocio.' },
    t16: { titulo: 'Tu Cuenta Reservaria', sub: 'La usas en todos los negocios que trabajan con Reservaria. Solo tú puedes cambiarla.' },
    t17: { titulo: 'Cambiar tu nombre', sub: 'Lo recibirán los negocios donde te has identificado.' },
    t18: { titulo: 'Quitar tu email', sub: 'Te escribiremos solo por tu teléfono. Si un negocio no tiene WhatsApp conectado, no podrá mandarte las confirmaciones.' },
    t19: {
        titulo: 'Tus negocios',
        sub: 'Cada negocio solo ve lo tuyo con él y no sabe en qué otros negocios estás. Elige por dónde te escribe y qué te puede mandar.',
        vacioTitulo: 'Todavía no tienes perfil en ningún negocio',
        vacioSub: 'Aparecerán aquí cuando reserves o pidas cita en uno, identificándote con tu teléfono.',
    },
    t20: {
        porCanal: 'Confirmaciones y pases por',
        respaldo: 'Si no llega por ahí, te lo mandamos por email.',
        siempre: 'Confirmaciones, pases y recordatorios',
        siempreAyuda: 'Se envían siempre que tengas algo con este negocio.',
    },
    t21: {
        etiqueta: (canal: string) => `Ofertas y novedades por ${canal}`,
        si: (fecha: string) => `Sí, desde el ${fecha}`,
        no: 'No',
        baja: (fecha: string) => `Te diste de baja el ${fecha}`,
        pendiente: 'Pendiente de confirmar',
        activalo: 'Actívalo si las quieres.',
        apuntaron: (negocio: string, fecha: string) => `Lo apuntaron en ${negocio} el ${fecha}`,
    },
    t22: { copia: 'Pedir una copia', correccion: 'Pedir una corrección', borrar: 'Borrar mis datos aquí', otros: 'Otros derechos' },
    t23: {
        titulo: 'Te proponen un cambio',
        sub: 'Solo cambia si lo aceptas. Si no haces nada, caduca a los 30 días.',
        nombre: 'propone corregir tu nombre.',
        email: 'propone corregir tu email.',
        ahora: 'Ahora',
        propuesto: 'Propuesto',
        rechazar: 'Rechazar',
        aceptar: 'Aceptar',
    },
    t24: {
        titulo: 'Tus solicitudes',
        sub: 'Hay un mes para responder, ampliable dos meses más en casos complejos: si pasa, te avisamos con el motivo. Te avisamos por tu canal preferido.',
        tipo: { access: 'Copia de tus datos', rectification: 'Corrección de datos', erasure: 'Borrado de tus datos' },
        todaLaCuenta: 'toda la cuenta',
        estado: {
            received: 'Recibida',
            scheduled: 'Programada',
            in_progress: 'En curso',
            extended: 'Ampliada',
            resolved: 'Resuelta',
            blocked: 'Bloqueada por obligación legal',
            rejected: 'Rechazada',
        },
        aepd: 'Puedes reclamar ante la Agencia Española de Protección de Datos',
    },
    t25: { titulo: (negocio: string) => `Pedir una copia de tus datos en ${negocio}`, sub: 'Te mandamos el enlace por tu canal preferido cuando esté lista; como máximo, en un mes.' },
    t26: {
        titulo: (negocio: string) => `Pedir una corrección a ${negocio}`,
        sub: 'Lo atiende el negocio, en un mes como mucho. Tu nombre, teléfono y email los cambias tú aquí mismo.',
        campo: 'Qué hay que corregir',
        ayuda: 'Por ejemplo: «Mi apellido es Romero».',
    },
    t27: {
        titulo: (negocio: string) => `Borrar tus datos en ${negocio}`,
        sub: (negocio: string) =>
            `${negocio} dejará de tener tus datos, tus notas y lo que aceptaste recibir. Tu cuenta y los demás negocios no cambian. Lo que la ley obliga a guardar (facturas y pagos) se conserva el tiempo legal, sin tus datos de contacto. No se puede deshacer.`,
    },
    t28: {
        titulo: 'Tu cuenta entera',
        sub: 'Una copia de todo lo que Reservaria y tus negocios guardan de ti, o borrar tu cuenta y tus datos en todos ellos.',
        copia: 'Pedir una copia de todo',
        borrar: 'Borrar mi Cuenta Reservaria',
    },
    t29: { titulo: 'Pedir una copia de todo', sub: 'Reunimos tu Cuenta Reservaria y lo que guarda cada negocio. Te mandamos el enlace por tu canal preferido; tenemos un mes como mucho.' },
    t30: {
        titulo: 'Borrar tu Cuenta Reservaria',
        sub: 'Borramos tu cuenta y tus datos en todos tus negocios. Lo que la ley obliga a guardar (facturas y pagos) se conserva el tiempo legal, sin tus datos de contacto. Si vuelves a usar Reservaria, empezarás con una cuenta nueva. No se puede deshacer.',
    },
    t31: {
        titulo: 'Confirma que eres tú',
        // T31 nombra «borrar tus datos» y «cambiar tu teléfono»; el de unir cuentas es el del dibujo (2.10 confirmar-codigo-unir).
        sub: (para: 'borrar' | 'telefono' | 'unir', telefono: string) =>
            `Para ${para === 'borrar' ? 'borrar tus datos' : para === 'telefono' ? 'cambiar tu teléfono' : 'unir tus dos cuentas'} necesitamos un código reciente. Te lo mandamos por WhatsApp al ${telefono}.`,
        // Cuenta nacida solo con el email (G365): el código va a su email. Texto a validar.
        // «Añade tu teléfono» (G366, 2.9) es A_VALIDAR.anadeTelefono.
        subEmail: (para: 'borrar' | 'telefono' | 'unir', email: string) =>
            `Para ${para === 'borrar' ? 'borrar tus datos' : para === 'telefono' ? 'añadir tu teléfono' : 'unir tus dos cuentas'} necesitamos un código reciente. Te lo mandamos por email a ${email}.`,
    },
    t32: {
        tituloCuenta: 'Se cancelará lo que tienes pendiente',
        tituloNegocio: (negocio: string) => `Tienes algo pendiente en ${negocio}`,
        sub: 'Al borrar tus datos se cancelará lo que tienes pendiente y se avisará al negocio:',
        devolucion: (negocio: string) => `Si has pagado algo, la devolución depende de las condiciones de ${negocio}.`,
        ley: 'Lo que la ley obliga a guardar (facturas y pagos) se conserva el tiempo legal, sin tus datos de contacto. No se puede deshacer.',
        /** G511: los pedidos de entradas futuros se cancelan sin reembolso; la ventana T32 dice cuántos. Frase validada por el equipo (G568). */
        pedidosSinReembolso: (n: number) =>
            n === 1 ? 'Tu pedido de entradas para un evento futuro se cancelará sin reembolso.' : `Tus ${String(n)} pedidos de entradas para eventos futuros se cancelarán sin reembolso.`,
        si: 'Sí, borrar',
        cuandoTermine: 'Borrar cuando termine',
        no: 'No borrar',
    },
    t33: {
        titulo: 'Estamos borrando tu Cuenta Reservaria',
        sub: 'Hemos cancelado lo que tenías pendiente y avisado a cada negocio.',
        ley: 'Lo que la ley obliga a guardar (facturas y pagos) se conserva el tiempo legal, sin tus datos de contacto.',
        nueva: 'Si vuelves a usar Reservaria, será con una cuenta nueva.',
    },

    // 12.3 Unir cuentas
    t34: {
        titulo: 'Ese teléfono ya tiene otra Cuenta Reservaria',
        sub: (telefono: string) => `Acabas de demostrar que el ${telefono} también es tuyo. Puedes unir las dos cuentas en esta.`,
        unir: 'Unir las dos cuentas',
        ahoraNo: 'Ahora no',
    },
    t35: {
        titulo: 'Unir tus dos cuentas',
        sub: (telefono: string) =>
            `Tus negocios, reservas y lo que aceptaste recibir en la cuenta del ${telefono} pasan a esta. Si un permiso está dado en una y retirado en la otra, se queda retirado. Los negocios donde usabas la otra cuenta verán el nombre, el teléfono y el email de esta. No se puede deshacer.`,
        accion: 'Unir las cuentas',
    },

    // 12.4 Enlaces de un toque
    t36: {
        titulo: (negocio: string, canal: string) => `¿Dejas de recibir ofertas de ${negocio} por ${canal}?`,
        sub: 'Es un toque. Seguirás recibiendo las confirmaciones, los pases y los recordatorios de lo que reserves.',
        baja: 'Darme de baja',
        elegir: 'Elegir qué recibo',
    },
    t37: {
        titulo: (negocio: string, canal: string) => `Ya no recibirás ofertas de ${negocio} por ${canal}`,
        sub: 'Seguirás recibiendo las confirmaciones, los pases y los recordatorios de lo que reserves.',
        nota: 'Para volver a apuntarte, entra en «Mis datos» con tu teléfono o tu email.',
        yaTitulo: (negocio: string, canal: string) => `Ya no recibes ofertas de ${negocio} por ${canal}`,
        yaSub: 'No tienes que hacer nada más. Seguirás recibiendo las confirmaciones de lo que reserves.',
        noValidoTitulo: 'Este enlace ya no funciona',
        noValidoSub: 'Puede que sea muy antiguo o que esté incompleto. Puedes darte de baja desde «Mis datos» o respondiendo BAJA al mensaje.',
    },
    t38: {
        titulo: (negocio: string, canal: string) => `¿Quieres recibir ofertas de ${negocio} por ${canal}?`,
        sub: (negocio: string, fecha: string, canal: string) =>
            `En ${negocio} nos dijiste el ${fecha} que querías recibir sus ofertas por ${canal}. Solo te escribirán si lo confirmas aquí, y puedes darte de baja en cualquier mensaje.`,
        si: 'Sí, quiero recibirlas',
        no: 'No, gracias',
        caduca: 'Este enlace sirve una vez y caduca a los 7 días.',
        aceptadoTitulo: (canal: string) => `Listo: recibirás sus ofertas por ${canal}`,
        aceptadoSub: 'Puedes darte de baja en cualquier mensaje o en «Mis datos».',
        rechazadoTitulo: 'No te enviaremos ofertas',
        rechazadoSub: (negocio: string) => `${negocio} no te escribirá para ofertas ni novedades. Seguirás recibiendo las confirmaciones de lo que reserves.`,
        caducadoTitulo: 'Este enlace ya no funciona',
        caducadoSub: 'Caduca a los 7 días y solo sirve una vez. Si quieres recibir ofertas, actívalo en «Mis datos».',
    },
    t39: {
        titulo: 'Tu copia de datos está lista',
        sub: 'Un resumen en PDF y tus datos en JSON y CSV, para guardarlos o llevarlos a otro servicio.',
        caduca: 'Este enlace sirve una vez y caduca a los 7 días de enviártelo. Al pulsar, la descarga dura 15 minutos.',
        descargar: 'Descargar mi copia',
        guardala: 'Guárdala en un sitio seguro: lleva tus datos personales.',
        caducadoTitulo: 'Este enlace ha caducado',
        caducadoSub: 'Los enlaces de la copia sirven una vez y caducan a los 7 días. Pide otra copia en «Mis datos».',
    },
} as const;

/** Textos del dibujo que no son de la asesoría (botones, estados y avisos de 2.9 a 2.11). */
export const D = {
    telefono: 'Teléfono',
    email: 'Email',
    enviarmeCodigo: 'Enviarme el código',
    enviarCodigo: 'Enviar el código',
    enviando: 'Enviando…',
    comprobar: 'Comprobar',
    comprobando: 'Comprobando…',
    pedirOtro: 'Pedir otro código',
    creandoCuenta: 'Creando tu cuenta…',
    cambiarTelefono: 'Cambiar el teléfono',
    cambiarEmail: 'Cambiar el email',
    caducaEn: (mmss: string) => `Caduca en ${mmss}`,
    caducado: 'Caducado',
    sinIntentos: 'Sin intentos',
    reenviarEn: (s: number) => `Reenviar en ${String(s)} s`,
    reenviar: 'Reenviar el código',
    porSms: 'Por SMS',
    porEmail: 'Por email',
    otroEnviado: 'Te hemos enviado otro código. El anterior ya no sirve.',
    incorrecto: (quedan: number) => (quedan === 1 ? 'Código incorrecto. Te queda 1 intento.' : `Código incorrecto. Te quedan ${String(quedan)} intentos.`),
    caducadoCodigo: 'Ha caducado: el código dura 10 minutos. Pide uno nuevo.',
    agotado: 'Has usado los 3 intentos. Pide un código nuevo.',
    captcha: 'No hemos podido comprobar que no eres un robot. Vuelve a intentarlo.',
    escribeTelefono: 'Escribe tu teléfono, con el prefijo si no es de España.',
    escribeEmail: 'Escribe un email válido.',
    escribeNombre: 'Escribe tu nombre.',
    usarTelefono: 'Usar mi teléfono',
    hola: (nombre: string) => `Hola, ${nombre}`,
    bienvenida: (nombre: string) => `Te damos la bienvenida, ${nombre}`,
    seguir: 'Seguir',
    misMensajes: { titulo: 'Entra en Mis mensajes', sub: 'Para ver lo que te ha mandado el negocio y pedirlo otra vez si no te ha llegado. Te mandamos un código; sin contraseñas.' },
    // 11.10: el negocio aún no se conoce antes de entrar (la dirección no lo lleva): «con el negocio».
    misConversaciones: { titulo: 'Entra en tus conversaciones', sub: 'Para leer lo que has hablado con el negocio, entra con tu Cuenta Reservaria: te mandamos un código, sin contraseñas.' },
    // 6.7: el negocio aún no se conoce antes de entrar (la dirección no lo lleva): el texto del diseño sin «en [negocio]».
    misPases: { titulo: 'Entra en Mis pases', sub: 'Para ver tus entradas, reservas y citas con QR, y volver a pedirlas. Te mandamos un código; sin contraseñas.' },
    misPagos: { titulo: 'Entra en Mis pagos', sub: 'Para ver lo que has pagado, lo que te hemos devuelto y tus recibos. Te mandamos un código; sin contraseñas.' },
    misCitas: { titulo: 'Entra en Mis citas', sub: 'Para ver, cambiar o cancelar tus citas. Te mandamos un código; sin contraseñas.' },
    sesionCaducada: { titulo: 'Tu sesión ha caducado', sub: 'Por seguridad dura 30 minutos. Pide otro código para seguir.' },
    nuevoTelefono: { titulo: 'Tu teléfono nuevo', sub: 'Te mandamos un código a ese número para comprobar que es tuyo.', campo: 'Teléfono nuevo' },
    nuevoEmail: { titulo: 'Tu email nuevo', sub: 'Te mandamos un código a ese email para comprobar que es tuyo.', campo: 'Email nuevo', quitar: 'Prefiero quitar mi email' },
    salir: 'Salir',
    misDatos: 'Mis datos',
    irAMisDatos: 'Ir a Mis datos',
    cargando: 'Un momento…',
    errorCarga: 'No hemos podido cargar tus datos',
    errorCargaSub: 'Comprueba la conexión y prueba de nuevo.',
    reintentar: 'Reintentar',
    errorGeneral: 'No hemos podido hacerlo. Prueba de nuevo.',
    demasiadas: 'Has hecho muchos intentos seguidos. Espera un poco y prueba de nuevo.',
    nombre: 'Nombre',
    sinEmail: 'Sin email',
    cambiar: 'Cambiar',
    anadir: 'Añadir',
    verificado: 'Verificado',
    sinVerificar: 'Sin verificar',
    idioma: 'Idioma de tus mensajes',
    guardar: 'Guardar',
    quitarEmail: 'Quitar el email',
    pedirCopia: 'Pedir la copia',
    pidiendo: 'Pidiendo…',
    enviar: 'Enviar',
    cuentale: 'Cuéntales qué hay que corregir.',
    borrarMisDatos: 'Borrar mis datos',
    borrarMiCuenta: 'Borrar mi cuenta',
    borrandoTexto: 'Borrando…',
    uniendo: 'Uniendo…',
    caducaEl: (fecha: string) => `Caduca el ${fecha}`,
    pedida: (fecha: string) => `Pedida el ${fecha}`,
    respuestaAntes: (fecha: string) => `respuesta antes del ${fecha}`,
    pendiente: 'Pendiente',
    confirmacionesPor: (canal: string) => `Confirmaciones por ${canal}`,
    ofertasPor: (canales: string) => `ofertas por ${canales}`,
    sinOfertas: 'sin ofertas',
    hecho: { nombre: 'Nombre guardado.', idioma: 'Idioma guardado.', canal: 'Canal guardado.', permisoDado: 'Permiso dado.', permisoRetirado: 'Permiso retirado.', aceptada: 'Corrección aceptada.', rechazada: 'Corrección rechazada.' },
    pedido: { copia: 'Copia pedida.', correccion: 'Corrección pedida.', borrado: 'Borrado pedido.', programado: 'Borrado programado: se hará cuando termine lo que tienes pendiente.' },
    emailQuitado: 'Email quitado.',
    telefonoCambiado: 'Teléfono cambiado.',
    emailCambiado: 'Email cambiado.',
    cuentasUnidas: 'Cuentas unidas.',
    alergias: 'Alergias o intolerancias',
    quitar: 'Quitar',
    quitando: 'Quitando…',
    guardadoEl: (fecha: string) => `Guardado el ${fecha}`,
    enCurso: 'En curso',
    bajaHecha: 'Baja hecha',
    yaEstabas: 'Ya estabas de baja',
    enlaceNoValido: 'Enlace no válido',
    pendienteConfirmar: 'Pendiente de confirmar',
    confirmado: 'Confirmado',
    sinOfertasChip: 'Sin ofertas',
    caducadoChip: 'Caducado',
    lista: 'Lista',
    descargada: 'Descargada',
    ofertasYNovedades: 'Ofertas y novedades. Las confirmaciones de lo que reserves te llegan siempre.',
    por: (canal: string) => `Por ${canal}`,
    confirmando: 'Confirmando…',
    guardando: 'Guardando…',
    dandoDeBaja: 'Dándote de baja…',
    preparando: 'Preparando la descarga…',
    descargaEmpezada: 'Tu descarga ha empezado',
    descargaSub: (hora: string) => `Si no ha empezado, vuelve a pulsar: el archivo está disponible hasta las ${hora}.`,
    descargarOtraVez: 'Descargar otra vez',
} as const;

/**
 * TEXTO A VALIDAR (G242, G199): propuestas que la asesoría tiene que revisar antes de darlas por buenas. Se ven en la
 * página (llevan `data-texto-a-validar`) porque las decisiones las piden, pero no son literales de §12.
 */
export const A_VALIDAR = {
    /** «Añade tu teléfono» (G366, 2.9): una cuenta sin teléfono lo da nada más entrar; hasta entonces solo la ve. */
    anadeTelefono: {
        titulo: 'Añade tu teléfono',
        sub: 'Las Cuentas Reservaria van ahora con un teléfono. Añade el tuyo para seguir: no pierdes nada de tu cuenta, y hasta entonces solo puedes verla.',
        campo: 'Teléfono',
        cerrarSesion: 'Cerrar la sesión',
    },
    /** «Otros derechos» (T22, G199): lo redacta la asesoría con la política; este es un texto provisional. */
    otrosDerechos: {
        titulo: 'Otros derechos',
        sub: (negocio: string) =>
            `También puedes oponerte a que ${negocio} use tus datos o pedir que limite su uso. Escríbele por lo que indica su página de privacidad. Si no te atiende, puedes reclamar ante la Agencia Española de Protección de Datos.`,
        cerrar: 'Entendido',
    },
    /** Aviso de relación terminada (`MyProfile.ended`, G198, G204, G242). */
    terminada: {
        business_closed: (negocio: string, fecha: string) => `${negocio} ya no usa Reservaria. Desde el ${fecha} no guarda tus datos aquí; tu cuenta no cambia.`,
        inactivity: (negocio: string, fecha: string) => `${negocio} borró tus datos el ${fecha} porque hacía tiempo que no ibas. Tu cuenta no cambia.`,
    },
    /** Quitar las alergias guardadas (G192). */
    quitarAlergias: {
        titulo: 'Quitar tus alergias o intolerancias',
        sub: (negocio: string) => `${negocio} dejará de tenerlas en tu ficha y no las verá en tus próximas reservas. No se puede deshacer.`,
    },
    /** T32 con el ámbito de toda la cuenta: T32 solo trae «las condiciones de [negocio]». */
    devolucionCuenta: 'Si has pagado algo, la devolución depende de las condiciones de cada negocio.',
} as const;
